export class SlidingWindowOptions {
  constructor(
    public title: string = '',
    public secondaryButtonText: string | null = $localize`Close`,
    public primaryButtonText: string = $localize`Save`,
    public completedStateText: string = $localize`Done`
  ) {}
}
